import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

function VerificationModal() {
  const User = useSelector((state) => state.userProfile.profile);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation(); // Get current route location
  console.log("location",location)

  useEffect(() => {
    const isAadhaarVerified = User.Userdata?.aadharverification;
    const isPanVerified = User.Userdata?.panverification;
    const isOnProfilePage = location.pathname === "/MyProfile";
    const isHomePage = location.pathname === "/";
    
    // Only show modal if not verified AND not on profile page
    setShowModal((!isAadhaarVerified || !isPanVerified) && !isOnProfilePage);
    isHomePage == true && setShowModal(false)
  }, [
    User.Userdata?.aadharverification, 
    User.Userdata?.panverification,
    location.pathname // Add to dependencies
  ]);

  if (!showModal) return null;

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="modal fade show" style={{ 
      display: 'block', 
      backgroundColor: 'rgba(0,0,0,0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1050
    }}>
      <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Complete KYC Verification</h5>
          </div>
          <div className="modal-body">
            <p className="text-heading">
              Complete Your KYC Verification
              To start receiving leads and unlock exclusive benefits on our platform, 
              please complete your KYC verification. This helps us ensure a secure 
              and trusted environment for all agents.
            </p>
          </div>
          <div className="modal-footer">
            <Link to="/MyProfile" onClick={closeModal}>
              <button
                style={{ backgroundColor: "#28a745" }}
                type="button"
                className="btn btn-success"
              >
                Verify Now
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerificationModal;